import { useState, useEffect } from 'react';

export function useData(endpoint, isConditionMet = true, defaultData = null, valueKeyword = 'value') {
  const [data, setData] = useState(defaultData);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isConditionMet) {
      // Set loading to false when the condition is not met
      setIsLoading(false);
      // Clear the data when the condition is not met
      setData(defaultData);
      return;
    }

    let isMounted = true;

    const fetchData = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const response = await fetch(endpoint);

        if (!response.ok) {
          const responseError = await response.json();
          if (responseError.error) {
            throw new Error(responseError.error);
          }

          throw new Error('An error occurred while fetching the data');
        }

        const result = await response.json();

        if (result.error) {
          throw new Error(result.error);
        }

        if (isMounted) {
          setData(result[valueKeyword] ?? result);
        }
      } catch (error) {
        if (isMounted) {
          setError(error.message);
          console.error('Error fetching data:', error);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [endpoint, isConditionMet]); // endpoint and isConditionMet are dependencies

  return { data, isLoading, error, setData };
}
